var _defs, _circle, _rect, _polygon, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNovapointTunnelGeoRockSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointTunnelGeoRock_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.5,
    cy: 7.5,
    r: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.32,
    y: 10.36,
    width: 3.5,
    height: 5.6,
    rx: 0.7,
    transform: "translate(-0.79 24.41) rotate(-44.99)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.52 29.77 10.39 32 12.55 25.82 24.93 13.44 28.89 17.4 16.52 29.77"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.5,
    cy: 7.5,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.5,
    cy: 7.5,
    r: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.5,
    cy: 12.5,
    r: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.5,
    cy: 12.5,
    r: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.5,
    cy: 12.5,
    r: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.5,
    cy: 17.5,
    r: 1.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.5,
    cy: 17.5,
    r: 1.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.44 22 5 22 4 22 4 4 5 4 21 4 21 14.44 23 12.44 23 4 23 2 5 2 4 2 3 2 2 2 2 24 3 24 4 24 5 24 11.44 24 13.44 22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointTunnelGeoRockSvg);
export default __webpack_public_path__ + "static/media/NovapointTunnelGeoRock_svg.387bc63d871ba7bb51aa0ba9bc4434c9.svg";
export { ForwardRef as ReactComponent };